module.exports = __webpack_public_path__ + "h5/media/bet.6795aaf0.mp3";